'use strict';
var nodes = document.querySelectorAll('.population');
var nums = [];
nodes.forEach(function(node) {
    var text = node.textContent;
    var cleaned = text.replace(/[^\d.-]+/g, '');
    var value = Number(cleaned);
    if (Number.isFinite(value)) nums.push(value);
});
var total = (nums || []).reduce(function(s, n) {
    return s + Number(n);
}, 0);
var average = nums.length ? total / nums.length : 0;
var formattedTotal = total.toLocaleString('en-US');
var formattedAverage = Math.round(average).toLocaleString('en-US');
document.querySelector('.total-population').textContent = formattedTotal;
document.querySelector('.average-population').textContent = formattedAverage;

//# sourceMappingURL=js_get_data_DOM.dd719c6e.js.map
